
import * as R from 'ramda'
import { call, reducer } from '../../helpers/api/meta'
import { getCourses } from '../../helpers/api/api';

export const GET_AR_COURSES_DATA = 'GET_AR_COURSES_DATA'

export const callGetCourses = (inputs) => {
    const meta = {
        endpoint: (params) => getCourses(params),
        inputs,
        action: GET_AR_COURSES_DATA,
        messages: {
            id: 'getCourses',
            failure: 'Could not get course detail'
        }
    }
    return call(meta)
}

const initialState = {
    loading: false,
    results: []
}

const saveCourses = (state, action) => {
    return R.assoc('results', action.results, state);
}

const messages = {
    loadFailed: 'Could not load courses.',
}

export default reducer(initialState, GET_AR_COURSES_DATA, saveCourses, messages.loadFailed)